import { useEffect, useLayoutEffect, useState } from 'react';

import './Modal.scss';

const Modal = ({
    modalClass = '',
    onShouldRender = null,
    isOpen = false,
    onCancel = null,
    children,
    isModalFullScreen = false,
    isModalSmall = false,
    isModalQuick = false,
}) => {
    const [shouldRender, setShouldRender] = useState(isOpen);
    const [animationClass, setAnimationClass] = useState('');

    useLayoutEffect(() => {
        // if (isModalFullScreen) {
        //     if (isOpen) {
        //         setShouldRender(true);
        //         setAnimationClass('fade-in-modals-fullscreen');
        //     } else if (shouldRender) {
        //         setAnimationClass('fade-out-modals-fullscreen');
        //     }
        // } else {
        if (isOpen) {
            setShouldRender(true);
            setAnimationClass('in');
        } else if (shouldRender) {
            setAnimationClass('out');
        }
        // }
    }, [isOpen]);

    const handleAnimationEnd = (e) => {
        if (e.target !== e.currentTarget) return;
        if (!isOpen) {
            setShouldRender(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            onShouldRender?.();
        }
    }, [shouldRender]);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel?.();
        }
    };

    /* Close on ESC */
    useEffect(() => {
        if (!isOpen) return;

        const handleKey = (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                e.preventDefault();
                onCancel?.();
            }
        };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [isOpen, onCancel]);

    if (!shouldRender) return null;

    /* Modal markup (via portal so it sits above rest of DOM) */
    return (
        <div
            className={`modal ${modalClass}`}>
            <div className={`modal-overlay ${animationClass === 'in' ? 'fade-in-modals-overlay' : animationClass === 'out' ? 'fade-out-modals-overlay' : ''}`} onClick={handleOverlayClick}></div>
            <div className={`modal-content ${animationClass === 'in' ? 'fade-in-modals' : animationClass === 'out' ? 'fade-out-modals' : ''} ${isModalFullScreen ? 'modal-fullscreen' : ''} ${isModalSmall ? 'modal-small' : ''} ${isModalQuick ? 'modal-quick' : ''}`} onAnimationEnd={handleAnimationEnd}>
                {children}
            </div>
        </div>
    );
};

export default Modal;
